import React from 'react'
import cx from 'classnames'
import style from './currency.module.scss'
import PropTypes from 'prop-types'
import VegaColors from '../../../resources/constants/colors.module.scss'

const VegaCurrency = ({
	className,
	color = VegaColors.SLATE1,
	size = 'small',
	trigram
}) => {
	return (
		<div
			className={cx(className, style[size], style.currency, {
				[style.placeholder]: !trigram
			})}
			style={{ color: color, borderColor: color }}
		>
			{trigram || 'EUR'}
		</div>
	)
}

VegaCurrency.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Color of the trigram and his border */
	color: PropTypes.oneOf(Object.values(VegaColors)),
	/** Choose between two sizes */
	size: PropTypes.oneOf(['small', 'big']),
	/** Trigram ISO 4217 of the currency */
	trigram: PropTypes.string
}

export { VegaCurrency }
